module.exports = __webpack_public_path__ + "static/media/provider_smaller.333d866a.jpg";